export default __webpack_public_path__ + "1577f24e1c31037885ff7962a55d6ee6.svg";